/*
 * -----------------------------------------------------------------------
 *  <copyright file="copy-button/index.ts" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState } from 'react';
import { useClipboard } from 'use-clipboard-copy';

import { useBoolean, useTranslation } from 'hooks';
import DarkTooltip from 'views/components/core/dark-tool-tip/dark-tool-tip';

import './styles.scss';

interface CopyButtonInterface {
    value: string;
    customClass?: string;
}

const CopyButton = ({ value, customClass }: CopyButtonInterface) => {
    const { t } = useTranslation();
    const openToolTip = useBoolean(false);
    const clipboard = useClipboard();

    const copyToClipboard = (e: any) => {
        e.preventDefault();
        clipboard.copy(value);
        openToolTip.setTrue();
        setTimeout(() => {
            openToolTip.setFalse();
        }, 2000);
    };
    return (
        <DarkTooltip open={openToolTip.value} title={t('Copied')} placement="top" arrow>
            <button type="button" onClick={copyToClipboard} className={`${customClass} copy-btn`}>
                <FontAwesomeIcon
                    style={{ color: '#7f7f7f', fontSize: 14 }}
                    icon={['far', 'copy']}
                    className="times-circle icon"
                />
            </button>
        </DarkTooltip>
    );
};

export default CopyButton;
